import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

const loadItinerariesPage = () => import("./itineraries").then((m) => ({ default: m.ItinerariesPage }));
const loadOthersPage = () => import("./others/itineraries-others").then((m) => ({ default: m.ItinerariesOthersPage }));
const loadOthersTagPage = () =>
  import("./others/tag/itineraries-others-tag").then((m) => ({ default: m.ItinerariesOthersTagPage }));

// One screen at two paths, so the layout can present each differently.
export const itinerariesRoutes: RouteRender[] = [
  lazyView(routes.itineraries, loadItinerariesPage, "Itineraries"),
  lazyView(routes.account.itineraries, loadItinerariesPage, "Itineraries"),
  lazyView(routes.otherItineraries.list, loadOthersPage, "Other Itineraries"),
  lazyView(routes.account.otherItineraries.list, loadOthersPage, "Other Itineraries"),
  lazyView(routes.otherItineraries.tag, loadOthersTagPage),
  lazyView(routes.account.otherItineraries.tag, loadOthersTagPage),
];
